const missingDataPopupExceptionsStatusCodes = Object.freeze([
  "missingAndPassiveDataSources",
  "missingDataSources",
  "missingIntegrations",
]);

export {
  missingDataPopupExceptionsStatusCodes
}



// WEBPACK FOOTER //
// ./src/enums/packages/index.js